import type { ApiErrorBody, RouteRequest, RouteResult } from '../types';

export class RouteApiError extends Error {
  constructor(public readonly code: ApiErrorBody['error']['code']) {
    super(code);
  }
}

export async function calculateRoute(
  request: RouteRequest,
  signal?: AbortSignal,
): Promise<RouteResult> {
  const response = await fetch('/api/route', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(request),
    signal: signal ?? null,
  });
  if (!response.ok) {
    const body = await response.json<ApiErrorBody>().catch((): ApiErrorBody => ({
      error: { code: 'UPSTREAM_ERROR' },
    }));
    throw new RouteApiError(body.error.code);
  }
  return response.json<RouteResult>();
}

export function plannedDepartureDefault(): string {
  return '2026-08-12T12:00';
}

export function plannedDepartureToIso(value: string): string | null {
  if (!/^2026-(?:07|08)-\d{2}T\d{2}:\d{2}$/.test(value)) return null;
  // Mainland Spain and the Balearics use CEST (UTC+02:00) throughout the
  // supported July–August planning window, regardless of the visitor's zone.
  const date = new Date(`${value}:00+02:00`);
  if (Number.isNaN(date.getTime())) return null;
  const earliest = Date.parse('2026-06-30T22:00:00Z');
  const latest = Date.parse('2026-08-12T21:59:00Z');
  return date.getTime() >= earliest && date.getTime() <= latest ? date.toISOString() : null;
}
